import classNames from 'classnames';
import React from 'react';
import { Icon as PPReactIcon } from '@paypalcorp/pp-react-icons';

const ICON_COLOR_DEFAULTS = {
  URL: 'cw-notifications__avatar',
  PPUI: 'cw-notifications__avatar--color_blue',
  INITIALS: 'cw-notifications__avatar--color_green',
};
interface NotificationIconProps {
  iconType: string;
  iconIdentifier: string;
  iconColor: string;
}
export default function NotificationIcon({ iconType, iconIdentifier, iconColor }: NotificationIconProps) {
  const defaultImageStyle = {
    borderWidth: '0px',
  };

  const getAvatarClassNames = (iconColor) => {
    const avatarColor = iconColor
      ? `cw-notifications__avatar--color_${iconColor.toLowerCase()}`
      : ICON_COLOR_DEFAULTS[iconType];
    return `${avatarColor}`;
  };

  const avatarClassNames = classNames(
    'cw-notifications__avatar',
    'cw-notifications__avatar--size_md',
    getAvatarClassNames(iconColor),
  );
  const style = !iconColor ? defaultImageStyle : {};
  return (
    <span className="cw_notification-descriptionIcon_new" aria-hidden="true">
      <div className={avatarClassNames} style={style}>
        {iconType === 'URL' && <img className="cw-notifications__avatar-image" src={iconIdentifier} alt="" />}
        {iconType === 'PPUI' && <PPReactIcon name={iconIdentifier} color="sysColorBackgroundSurface" size="md" />}
        {iconType === 'INITIALS' && iconIdentifier}
      </div>
    </span>
  );
}
